import { useNavigate } from "react-router-dom";

/**
 * The button's conic-gradient ring must stay fully opaque all the way around -
 * a transparent stop reads as a broken border, not a moving highlight.
 */
export default function SelfCareChallengeSection({ section }) {
  const navigate = useNavigate();

  return (
    <section className="mt-8">
      <h2 className="m-0 text-base font-semibold text-[#1E2D3D] sm:text-lg">
        {section.title}
      </h2>
      {section.description && (
        <p className="m-0 mt-1 text-sm text-[#555555] sm:text-base">
          {section.description}
        </p>
      )}

      <div className="mt-4 flex flex-col items-start gap-3 rounded-lg border border-[#DDDDDD] bg-white p-4 sm:p-6">
        <p className="m-0 text-sm text-[#555555] sm:text-base">{section.body}</p>

        <div className="relative inline-flex overflow-hidden rounded-full">
          <span className="absolute inset-[-1000%] animate-spin bg-[conic-gradient(from_0deg,#1c5486_0%,#22d3ee_50%,#1c5486_100%)]" />
          <button
            type="button"
            onClick={() => {
              navigate(section.to);
              // React Router keeps scroll position across routes.
              window.scrollTo(0, 0);
            }}
            className="relative m-[2px] rounded-full bg-white px-6 py-2 text-[15px] font-semibold text-[#1c5486] transition sm:text-base"
          >
            {section.ctaLabel}
          </button>
        </div>
      </div>
    </section>
  );
}
